import {
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { CartObserver} from "src/app/core/services/cart-service";
import { ObserverPedido } from "src/app/core/services/pedido-service";
declare var $: any;
import "@angular/localize/init";

@Component({
  selector: "app-show-details",
  templateUrl: "./show-details.component.html",
  styleUrls: ["./show-details.component.css"],
})
export class ShowDetailsComponent{
  @Input() cli: any
  @Input() identificacaoCliente: any
  
  public dropdown = false
  hoverDoc(c){
    return `${c.tipoDocumento}: ${c.numDocumento}`
  }
  
  hoverName(c){
    return `Nome: ${c.nome}`
  }
}
